import React from 'react'
import {connect} from 'react-redux'

import 'antd/dist/antd.css'
import {Col, message, Row, Select, Spin, Steps, Typography} from 'antd'
import {EditOutlined, FileAddOutlined} from '@ant-design/icons'
import {withRouter} from 'react-router'
import moment from 'moment'
import {patchArtwork, postArtwork, postArtworkAdmin} from '../../api/artworks'
import {patchArtworkConfig, postArtworkConfig} from '../../api/artworkConfigs'

import {getFileNameByUrl, getFullNameByArtist} from '../../app/util'

import HttpError from '../../component/base/HttpError'
import NewPiecesStepperBasic from '../../component/piece/NewPiecesStepperBasic'
import NewPiecesStepperDetail from '../../component/piece/NewPiecesStepperDetail'
import NewPiecesStepperBusinessType from '../../component/piece/NewPiecesStepperBusinessType'
import NewPiecesStepperPrice from '../../component/piece/NewPiecesStepperPrice'
import {loadForm, saveForm} from '../../app/cacheUtil'
import {
    cleanAllCachedNewPieces,
    newPiecesBasic,
    newPiecesBusinessType,
    newPiecesDetail,
    newPiecesPrice,
    newPiecesStepCount
} from '../../component/piece/common'
import {URL_PIECES} from '../../const'
import {is_admin_user} from "../../app/role";
import axios from "axios";

const {Option} = Select
const {Title, Text} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    artistId: state.user.info.artistId, //artist obj id
    email: state.user.info.email,
    role: state.user.info.role,
    artistNames: state.artist.artistNames
}))
class NewPiecesStepper extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            printsItemsVisible: false,
            printsPriceOptionsVisible: false,
            stepperCount: 0,
            businessType: null,
            width: 0,
            height: 0,
            depth: 0,
            actionLoading: false,
        }
        this.CancelToken = axios.CancelToken.source()
    }

    getArtworkId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArry = this.props.location.pathname.split('/')
            id = parseInt(locationArry[locationArry.length - 1])
        }
        return id
    }

    componentDidMount() {
        this.setState({
            stepperCount: 0
        })
    }

    cacheFieldsValue = (formId, value) => {
        saveForm(formId, value)
    }

    cacheStepperCount = (num) => {
        localStorage.setItem(newPiecesStepCount, num)
    }

    loadStepperCount = () => {
        try {
            const val = localStorage.getItem(newPiecesStepCount)
            if (typeof val === 'number' && 0 <= val && val <= 3) {
                //valid value by step
                return val
            }
        } catch (e) {
            return 0
        }
        return 0
    }

    submitFieldsValue = () => {
        const basic = loadForm(newPiecesBasic) ?? {}
        const detail = loadForm(newPiecesDetail) ?? {}
        // const business = loadForm(newPiecesBusinessType) ?? {}
        const price = loadForm(newPiecesPrice) ?? {}

        const values = {
            ...basic,
            ...detail,
            // ...business,
            ...price
        }
        this.onFinish(values)

        cleanAllCachedNewPieces()
    }

    onFinish = (values) => {
        const {
            name,
            medium_type_str,
            image,
            additional_image,
            material_type_str,
            style_type_str,
            content_info_str,
            color_info_str,
            label_str,
            year,
            month,
            day,
            price_type_str,
            extra_info_str,
            height,
            width,
            depth,
            size_desc_str,
            is_visible_gallery,
            is_display_watermark,
            is_framed,
            frame_desc,
            used_type,
            inventory_quantity,
            inventory_prints_quantity,
            prints_markup_percentage,
            prints_price_options,
            is_custom_prints_options
        } = values

        let additional_image_json_array = []
        let additional_image_str = undefined
        if (additional_image) {
            for (let i = 0; i < additional_image.length; i++) {
                let item = additional_image[i]
                const fileSize = parseInt(item.file_size)
                additional_image_json_array.push({
                    name: getFileNameByUrl(item.response.s3_url),
                    status: 'done',
                    thumbUrl: item.response.static_url,
                    url: item.response.s3_url,
                    size: isNaN(fileSize) ? 1 : fileSize
                })
            }
            additional_image_str = JSON.stringify(additional_image_json_array)
        }

        const getValidNum = (val) => {
            try {
                if (!isNaN(val)) return val.toString()
                return ""
            } catch (e) {
                return ""
            }
        }

        const artworkParam = {
            name,
            medium_type_str: medium_type_str?.join(','),
            material_type_str: material_type_str,
            style_type_str: style_type_str?.join(','),
            label_str,
            year,
            price_type_str,
            extra_info_str,
            size_type_str: getValidNum(height) + ',' + getValidNum(width) + ',' + getValidNum(depth),
            is_framed,
            frame_size_h: getValidNum(height),
            frame_size_w: getValidNum(width),
            frame_size_d: getValidNum(depth),
            size_desc_str: size_desc_str,
            s3_url: image[0].response !== undefined ? image[0].response.s3_url : image[0].url,
            static_url: image[0].response !== undefined ? image[0].response.static_url : image[0].thumbUrl,
            file_size: isNaN(image[0].size) ? 1 : image[0].size,
            used_type: used_type === undefined || used_type.length === 0 ? '' : used_type?.join(','),
            artwork_pieces_str: additional_image_str,
            content_info_str: content_info_str?.join(','),
            color_info_str: color_info_str?.join(',')
        }
        const user_created_date = moment(`${year}-${month ?? '01'}-${day ?? '01'}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
        const artworkConfigParam = {
            is_visible_gallery: !is_visible_gallery,
            is_display_watermark: !!is_display_watermark,
            is_framed,
            frame_size_h: getValidNum(height),
            frame_size_w: getValidNum(width),
            frame_size_d: getValidNum(depth),
            frame_desc: frame_desc,
            user_created_date,
            inventory_quantity: inventory_quantity,
            inventory_prints_quantity: inventory_prints_quantity,
            prints_markup_percentage: prints_markup_percentage,
            is_custom_prints_options: is_custom_prints_options
        }
        if (prints_price_options && is_custom_prints_options) {
            let sanity = (str) => {
                return str.replaceAll(':', '').replaceAll(';', '')
            }
            let item_str = []
            for (const item of prints_price_options) {
                let str = sanity(item.price_option) + ':' + item.price_value
                item_str.push(str)
            }
            artworkConfigParam['custom_prints_options'] = item_str.join(';')
        }
        this.setState({actionLoading: true})
        if (this.props.new === true) {
            if (!is_admin_user(this.props)) {
                postArtwork(artworkParam)
                    .then(async (response) => {
                        await postArtworkConfig({
                            artwork: response.data.id,
                            ...artworkConfigParam
                        })
                        message.success('Save successfully').then((r) => {
                        })
                        this.props.history.push({pathname: URL_PIECES})
                    })
                    .catch((error) => {
                        HttpError(error)
                    }).finally(() => {
                    this.setState({actionLoading: false})
                })
            } else {
                postArtworkAdmin({artist: this.props.artistId? this.props.artistId: values.artist, ...artworkParam})
                    .then(async (response) => {
                        await postArtworkConfig({
                            artwork: response.data.id,
                            ...artworkConfigParam
                        })
                        message.success('Save successfully').then((r) => {
                        })
                        this.props.history.push({pathname: URL_PIECES})
                    })
                    .catch((error) => {
                        HttpError(error)
                    }).finally(() => {
                    this.setState({actionLoading: false})
                })
            }
        } else {
            const id = this.getArtworkId()
            Promise.all([patchArtwork(id, artworkParam), patchArtworkConfig(id, {artwork: id, ...artworkConfigParam})])
                .then((response) => {
                    message.success('Update successfully').then((r) => {
                    })
                    this.props.history.push({pathname: URL_PIECES})
                })
                .catch((error) => {
                    HttpError(error)
                }).finally(() => {
                this.setState({actionLoading: false})
            })
        }
    }

    next = () => {
        this.cacheStepperCount(this.state.stepperCount + 1)
        this.setState({stepperCount: this.state.stepperCount + 1})
    }

    prev = () => {
        this.cacheStepperCount(this.state.stepperCount - 1)
        this.setState({stepperCount: this.state.stepperCount - 1})
    }

    render() {
        const {Step} = Steps
        const steps = [
            {
                title: 'Basic',
                content: (
                    <NewPiecesStepperBasic
                        formId={newPiecesBasic}
                        {...this.props}
                        artists={this.props.artistNames}
                        onFinish={(val) => {
                            if(val['width']) this.setState({width: val['width']})
                            if(val['height']) this.setState({height: val['height']})
                            if(val['depth']) this.setState({depth: val['depth']})
                            this.cacheFieldsValue(newPiecesBasic, val)
                            this.next()
                        }}
                    />
                )
            },
            {
                title: 'Detail',
                content: (
                    <NewPiecesStepperDetail
                        formId={newPiecesDetail}
                        {...this.props}
                        prev={this.prev}
                        onFinish={(val) => {
                            this.cacheFieldsValue(newPiecesDetail, val)
                            this.next()
                        }}
                    />
                )
            },
            // {
            //     title: 'Business Type',
            //     content: (
            //         <NewPiecesStepperBusinessType
            //             formId={newPiecesBusinessType}
            //             {...this.props}
            //             prev={this.prev}
            //             onFinish={(val) => {
            //                 this.setState({businessType: val})
            //                 this.cacheFieldsValue(newPiecesBusinessType, val)
            //                 this.next()
            //             }}
            //         />
            //     )
            // },
            {
                title: 'Price',
                content: (
                    <NewPiecesStepperPrice
                        formId={newPiecesPrice}
                        {...this.props}
                        prev={this.prev}
                        width={this.state.width}
                        height={this.state.height}
                        depth={this.state.depth}
                        actionLoading={this.state.actionLoading}
                        onFinish={(val) => {
                            this.cacheFieldsValue(newPiecesPrice, val)
                            this.submitFieldsValue()
                        }}
                    />
                )
            }
        ]

        return (
            <Spin size='large' spinning={false}>
                <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col>
                        <Title level={1} style={{marginBottom: 0}}>
                            {this.props.new === true ? ' New' : ' Edit'} Piece
                        </Title>
                    </Col>
                </Row>
                <div style={{minHeight: 540}}>{steps[this.state.stepperCount].content}</div>
                <Row style={{paddingLeft: '7vw', paddingRight: '7vw', marginTop: '4vw', marginBottom: '4vw'}}>
                    <Steps
                        labelPlacement='vertical'
                        current={this.state.stepperCount}
                        style={{marginLeft: 'auto', marginRight: 'auto', width: 640}}
                    >
                        {steps.map((item, index) => (
                            <Step key={item.title} title={item.title}/>
                        ))}
                    </Steps>
                </Row>
            </Spin>
        )
    }
}

export default withRouter(NewPiecesStepper)
